export default {
  title: 'Projets',
  create_offer_button: 'Créer un nouveau projet',
  create_offer_title: 'Créer un nouveau projet',
  create_offer_description:
    'Recruter une personne passionnée pour un projet clé. Créer dès maintenant votre projet et faites la différence !',
  published_jobs_title: 'Mes projets publiés',
  steps_previous: 'Étape précédente',
  steps_next: 'Étape suivante',
  breadcrumb_dashboard: 'Tableau de bord',
  breadcrumb_manager: 'Gestionnaires de projets',
  breadcrumb_jobs: 'Projets',
  publish_job_title: 'Publier votre projet',
  create_job_title: 'Créer un nouveau projet',
  wizard: {
    progress: 'Étape {{current}} sur {{total}} : {{step}}',
    steps: {
      details: 'Détails',
      duration: 'Durée',
      recruitment: 'Recrutement',
      review: 'Révision',
      payment: 'Paiement et confirmation',
    },
    select_services: 'Sélectionnez des services',
    loading_choices: 'Chargement des choix…',
    quote_submission_deadline: 'Date limite de soumission',
    expected_response_date: 'Date de réponse prévue (facultative)',
    listing_priority_help: 'Choisissez la visibilité de votre projet.',
    selected_listing_priority: 'Sélectionnée',
    loading_listing_priorities: 'Chargement des priorités d’affichage…',
    no_listing_priorities:
      'Aucune priorité d’affichage n’est disponible. Réessayez après avoir rechargé la page.',
    credit_count_one: '{{count}} crédit',
    credit_count_other: '{{count}} crédits',
    create_on_behalf_of: 'Créer au nom de (facultatif)',
    loading_recruiters: 'Chargement des recruteurs…',
    no_shadow_recruiter: 'Aucun recruteur représenté',
    ready_to_publish: 'Prêt à publier',
    ready_to_save_draft: 'Prêt à enregistrer le brouillon',
    admin_draft_help:
      'Ce projet créé par un administrateur sera enregistré comme brouillon non publié.',
    shadow_publish_help:
      'Ce projet pour un recruteur représenté sera publié sans consommer de crédits.',
    credit_publish_help: 'Cette action utilisera {{cost}} crédits. Votre solde est de {{balance}}.',
    insufficient_credits:
      'Vous avez besoin de plus de crédits. Achetez des crédits dans votre portefeuille, puis revenez ici pour continuer.',
    validation: {
      complete_required_details: 'Remplissez tous les renseignements requis avant de continuer.',
      choose_listing_priority: 'Choisissez une priorité d’affichage.',
      expires_at_before_today: 'La date limite de soumission doit être aujourd’hui ou plus tard.',
      expires_at_after_start_date:
        'La date limite de soumission ne peut pas être après la date de début du projet.',
      selection_date_before_expires_at:
        'La date de réponse prévue doit être après la date limite de soumission.',
      selection_date_after_start_date:
        'La date de réponse prévue ne peut pas être après la date de début du projet.',
      start_date_before_today: 'La date de début doit être aujourd’hui ou plus tard.',
      end_date_before_start_date: 'La date de fin ne peut pas être avant la date de début.',
    },
    actions: {
      discard_draft: 'Supprimer le brouillon',
      back: 'Retour',
      next: 'Suivant',
      publishing: 'Publication…',
      confirm_publish: 'Confirmer et publier',
      saving_draft: 'Enregistrement du brouillon…',
      save_draft: 'Enregistrer le brouillon',
    },
  },
  service_type: 'Type de services requis',
  wallet: 'Mon Porte-monnaie',
  credits: 'Mes jetons',
  manage: 'Gérer',
  back_to_job: 'Retour au projet',
  back_to_jobs: 'Retour à mes projets',
  close_and_back_to_my_offers: 'Fermer et retourner à mes projets',
  showContacts: 'Voir la fiche contact',
  manage_jobs: 'Gérer mes projets',
  job_published: 'Projet publié',
  job_updated: 'Projet modifié',
  job_hint:
    'Votre projet <strong>{{name}}</strong> est maintenanant visible sur le tableau de recherche des projets.',
  create_job_button: 'Créer mon projet',
  edit_job_button: 'Modifier mon projet',
  publish_job_button: 'Publier mon projet',
  change_priority_button: "Modifier la priorité d'affichage",
  save_and_publish: 'Enregistrer et publier',
  jobStatus: 'Statut',
  quote_counts: '{{count}} soumission reçue',
  quote_counts_plural: '{{count}} soumissions reçues',
  remove_offer: 'Retirer',
  cancel_changes: 'Abandonner les modifications',
  budget: 'Budget',
  published_at: 'Date de publication',
  requested_at: 'Date de demande',
  expires_at: 'Date limite de soumission',
  expired_at: 'Date limite de soumission dépassée le',
  expired: 'Expirée',
  reviewing_quotes: 'Révision des soumissions',
  selection_date: 'Date de réponse prévue',
  description_label: 'Description',
  removed: 'Retirée',
  renewing: 'Renouvellement…',
  renew: {
    free: 'Renouveler (gratuit)',
    success: 'Votre projet a été renouvelé pour 14 jours.',
    error: 'Le renouvellement a échoué. Veuillez réessayer.',
    removed_notice:
      'Ce projet a été retiré du babillard. Créez-en un nouveau pour continuer à recruter.',
    start_date_unavailable_notice:
      'Ce projet ne peut pas être renouvelé car sa date de début est trop proche. Modifiez la date de début pour permettre le renouvellement.',
  },
  project_info: 'Informations du projet',
  quote_requests: 'Demande de soumission',
  bidders: 'Pigistes soumissionnaires',
  cancelled: 'Annulé',
  paused: 'En pause',
  pause_offer: 'Mettre ce projet sur pause',
  reopen_offer: 'Reactiver le projet',
  reopen_unavailable_notice:
    "La date limite de soumission de ce projet est passée pendant qu'il était en pause; il ne peut plus être réactivé directement. Contactez le support pour le récupérer.",
  reopening: 'Réactivation…',
  pausing: 'Mise en pause…',
  starting_reviewing: 'Passage en révision…',
  reopen_job_success: 'Projet reactivé avec succès',
  reopen_job_error: 'Echec de la réactivation du projet',
  pause_job_success: 'Projet mis en pause avec succès',
  pause_job_error: 'Ecchec de mise en pause du projet',
  start_reviewing_offer: 'Commencer la révision des soumissions',
  start_reviewing_success: 'Le projet est maintenant en révision des soumissions.',
  start_reviewing_error: 'Échec du passage en révision des soumissions.',
  no_quotes_to_review_notice: 'Aucune soumission n’a encore été reçue pour ce projet.',
  viewJob: 'Voir le projet',
  viewProjectInfo: 'Voir les details',
  apply_for_offer: 'Demontrer son intérêt',
  close_and_back: 'Fermer et retourner aux projets',
  already_submitted_warning: 'Vous avez déjà créé une soumission pour ce projet.',
  go_to_my_quote: 'Voir ma soumission',
  go_to_my_quotes: 'Voir mes soumissions',
  findOffer: 'Trouver un projet',
  subtitle: 'Un projet',
  searchPlaceholder: 'Écrire un domaine ou une discipline',
  filter: 'Filtrer',
  sort: 'Trier',
  filterBy: 'Filtrer par',
  sortBy: 'Trier par',
  loadMore: 'Charger plus de résultats',
  showResults: 'Voir les résultats',
  alphabetical: 'Classement alphabétique',
  publishedAt: 'Classement par date de publication',
  rating: 'Évaluation',
  proximity: 'Proximité',
  addService: 'Ajouter un service',
  addCity: 'Ajouter une ville',
  maximum: 'Maximum',
  sorts: {
    az: 'A à Z',
    za: 'Z à A',
    allianceAsc: 'Croissant',
    allianceDesc: 'Décroissant',
    publishedAtDesc: 'Plus récent',
    publishedAtAsc: 'Plus ancien',
    proximity: 'Proximité',
  },
  searchErrorMessage: 'Une erreur est survenue lors de la recherche. Veuillez réessayer.',
  retry: 'Réessayer',
  contactSupport: 'Si le problème persiste, veuillez contacter le support.',
  noResults: 'Aucun projet trouvé.',
  refineSearch: "Essayez d'affiner vos critères de recherche pour obtenir de meilleurs résultats.",
  noJobs: "Vous n'avez pas encore créé de projets.",
  cancel_job: 'Retirer votre projet.',
  cancel_and_confirm: 'Confirmer et retirer',
  cancel_job_hint:
    'Votre projet <strong>{{name}}</strong> sera retiré du tableau de recherche de projets. Vous pourrez le replublier plus tard.',
  cancel_job_error: "Erreur lors de l'annulation du projet.",
  cancel_job_success: 'Votre projet a été retiré avec succès.',
  createQuoteErrorTitle: 'Erreur lors de la création',
  createQuoteErrorHint:
    'Une erreur est survenue lors de la création de votre Soumission. Veuillez réessayer.',
  publish: {
    priority_title: "Priorité d'affichage",
    priority_help:
      "Vous pouvez prioriser l'affichage de votre annonce afin de plus facilement recruter des pigistes pour votre projet. Vous disposez de trois niveaux de priorité avec un coût différent pour chaque.",
    expires_at_title: 'Date limite de soumission (inclusivement)',
    expires_at_help: "Votre offre n'acceptera plus de nouvelles soumissions après cette date.",
    expires_at_before_today_error:
      'La date limite de soumission doit être aujourd’hui ou plus tard.',
    expires_at_after_start_date_error:
      'La date limite de soumission ne peut pas être après la date de début du projet ({{startDate}})',
    selection_date_title: 'Date de réponse prévue (optionnel)',
    selection_date_help:
      'Indiquez aux pigistes à partir de quelle date vous commencerez à réviser les soumissions reçues.',
    selection_date_before_expires_at_error:
      'La date de réponse prévue doit être après la date limite de soumission',
    selection_date_after_start_date_error:
      'La date de réponse prévue ne peut pas être après la date de début du projet ({{startDate}})',
    use_credits_and_publish: 'Utiliser {{count}} jeton et publier',
    use_credits_and_publish_plural: 'Utiliser {{count}} jetons et publier',
    use_credits_and_modify: 'Utiliser {{count}} jeton et modifier',
    use_credits_and_modify_plural: 'Utiliser {{count}} jetons et modifier',
    loading: 'Chargement...',
    edit: 'Modifier',
    cancel: 'Annuler',
    priorities: {
      standard: {
        label: 'Standard',
        description: 'Affichage chronologique.',
        details: 'Standard (coût = {{count}} jeton)',
      },
      featured: {
        label: 'En vedette',
        description: 'Affichage en tête de page pendant 48 heures.',
        details: 'En vedette (coût = {{count}} jetons)',
      },
      urgent: {
        label: 'Urgent',
        description:
          'Affichage en tête-durant 7 Jours avec distinction visuelle. Les pigistes correspondant avec dans un rayon de 50km sont automatiquement notifiés.',
        details: 'Urgent (coût = {{count}} jetons)',
      },
    },
    success: 'Votre projet a été publié avec succès.',
    error: 'Erreur lors de la publication du projet.',
    already_published_error: 'Cette offre a déjà été publiée.',
  },
  form: {
    project_name: 'Nom du projet',
    project_name_placeholder: 'Inscrivez le nom de votre projet',
    project_name_help:
      "Choisir un nom de projet est une étape cruciale qui peut influencer la perception et le succès de votre initiative. Un bon nom doit être mémorable, refléter l'essence du projet et résonner avec votre public cible. Pensez à des mots qui évoquent des émotions ou des images positives, et n'hésitez pas à jouer avec des combinaisons de mots pour créer quelque chose d'unique.",
    location: 'Localisation',
    location_placeholder: 'Choisissez une ville',
    location_help:
      "Où se déroulera votre projet. Par défaut c'est la ville inscrite dans votre profil qui s'affichera.",
    price_range: 'Votre budget',
    budget_placeholder: '00$',
    description: 'Descriptif du projet',
    description_placeholder: 'Décrivez votre projet...',
    service_type: 'Ajouter les types de services',
    service_type_placeholder: 'Ajouter les types de services*',
    service_type_help:
      "Lorsque vous sélectionnez les types de services nécessaires pour votre projet, il est essentiel de bien comprendre les besoins spécifiques de votre initiative. Commencez par identifier les objectifs principaux et les résultats attendus. Ensuite, évaluez les ressources disponibles et les compétences de votre équipe. Pensez à des services tels que le développement web, le marketing digital ou la gestion de projet, en fonction de ce qui peut le mieux soutenir votre vision. Enfin, n'oubliez pas de considérer les retours d'expérience d'autres projets similaires pour affiner votre choix.",
    onsite: 'Travail en présentiel',
    onsite_no: 'Non',
    languages: 'Langue(s) parlée(s)',
    start_date: 'Date de début',
    end_date: "Date d'échéance",
    submit: 'Créer le projet',
    submitting: 'Création du projet...',
    error_required: 'Veuillez remplir tous les champs obligatoires.',
    error_budget: 'Le budget maximum doit être supérieur au minimum.',
    error_create: 'Erreur lors de la création du projet.',
    error_date_must_be_future: 'La date de début doit être future.',
    error_end_date_before_start: "La date d'échéance doit être postérieure à la date de début.",
    complete_required_fields: 'Veuillez compléter tous les champs obligatoires',
  },
  request_quote_modal: {
    title: 'Demander une soumission à {{freelancer}}',
    sent_title: 'Demande de soumission envoyée',
    sent_message:
      'Votre demande de soumission a été envoyée à {{freelancer_name}}. Vous pouvez gérer cette demande dans vos projets.',
    see_my_jobs: 'Voir mes demandes de soumission',
    close_and_return_to_profile: 'Fermer et retour au profil',
    error:
      "Une erreur est survenue lors de l'envoi de la demande de soumission. Veuillez réessayer ou contacter l'équipe de support.",
  },
  quotes_count_labels: {
    private_pending: 'En attente',
    private_rejected: 'Rejetée',
    quote_counts_zero: 'Aucune soumission reçue',
    quote_counts_one: '{{count}} soumission reçue',
    quote_counts_other: '{{count}} soumissions reçues',
    change_requested: 'Modification demandée',
    job_cancelled: 'Projet annulé',
    alliance_retired: 'Invitation retirée',
    public_draft: 'Brouillon',
    quote_accepted: 'soumission acceptée',
    quote_rejected: 'soumission rejetée',
    quote_counts: '{{count}} soumission(s)',
  },
  quoteAccepted: {
    title: 'Soumission acceptée',
    message:
      'Votre projet <bold>{{projectName}}</bold> sera désormais visible dans le gestionnaire de projets.',
    returnToJobs: 'Voir le gestionnaire de projets',
  },
  rejectQuote: {
    title: 'Refuser la soumission',
    message:
      'Pour Refuser la soumission veuillez fournir un bref message aux pigistes. Ils pourront proposer une nouvelle offre s’ils le désirent.',
    label: 'Votre message pour {{name}}',
    placeholder: 'Entrez votre message',
    cancel: 'Abandonner et retour au projet',
    send: 'Envoyer',
    success: {
      title: 'Soumission déclinée',
      message:
        'Votre projet reste actif dans vos projets. <bold>{{freelancers}}</bold> seront notifiés. Ils pourront proposer une nouvelle offre s’ils le désirent.',
      returnToJobs: 'Retour à mes projets',
    },
  },
  viewProject: 'Voir le projet',
  job_visibility_labels: {
    private: 'Demande de soumission',
    public: 'Projet',
  },
  bigSteps: {
    title: 'Les grandes étapes',
    subtitle: 'Pour partir du bon pied, voici ce que vous devez savoir!',
    steps: {
      one: {
        title: 'Décris ton projet',
        description: 'Explique ton besoin, le type de mandat et les compétences recherchées.',
      },
      two: {
        title: 'Ajoute les détails clés',
        description: 'Budget, échéancier, dates importantes et mode de collaboration.',
      },
      three: {
        title: 'Publie et reçois des propositions',
        description: 'Ton projet est visible par les pigistes intéressé.e.s.',
      },
    },
    needHelp: 'Besoin d’aide?',
    cta: 'Appel à l’action',
  },
  edit_job_title: "Modifier l'offre d'emploi",
  alphabeticalSort: 'Ordre alphabétique',
  createdAtSort: 'Date de création',
} as const;
